<template>
  <nav class="help-breadcrumb" aria-label="breadcrumb">
    <NuxtLink to="/website/service" class="help-breadcrumb__link">服务</NuxtLink>
    <span class="help-breadcrumb__sep">/</span>
    <NuxtLink :to="listRoute" class="help-breadcrumb__link">{{ centerLabel }}</NuxtLink>
    <span class="help-breadcrumb__sep">/</span>
    <span class="help-breadcrumb__current">{{ current || '内容详情' }}</span>
  </nav>
</template>

<script setup>
/**
 * @description 帮助中心面包屑导航组件
 * @param {string} current - 当前页面名称
 * @param {string|Object} listRoute - 帮助中心列表路由
 * @param {string} centerLabel - 中心名称
 */
defineProps({
  current: {
    type: String,
    default: '内容详情',
  },
  listRoute: {
    type: [String, Object],
    default: '/website/service/help',
  },
  centerLabel: {
    type: String,
    default: '帮助中心',
  },
})
</script>

<style lang="scss" scoped>
.help-breadcrumb {
  background-color: $bg-white;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  color: $text-subtitle-color;
  line-height: 1.5;

  @include respond-to-max('lg') {
    margin-bottom: 20px;
    font-size: 13px;
  }
}

.help-breadcrumb__link {
  color: $text-subtitle-color;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: $primary-color;
  }
}

.help-breadcrumb__sep {
  color: $text-subtitle-color;
}

.help-breadcrumb__current {
  color: $text-title-color;
}
</style>
